// Create-step constants and legacy preset re-exports.
export {
  BACK_PRESETS as DRESS_PRESETS_BACK,
  FRONT_PRESETS as DRESS_PRESETS,
} from "./presets";

// Color palette definitions for each dress preset type
export const COLOR_PALETTES = {
  wedding: [
    { name: "White", hex: "#FFFFFF", popular: true },
    { name: "Ivory", hex: "#FFFFF0", popular: true },
    { name: "Champagne", hex: "#F7E7CE", popular: true },
    { name: "Blush", hex: "#FFE4E1", popular: false },
    { name: "Pearl", hex: "#F8F6F0", popular: false },
  ],
  formal: [
    { name: "Black", hex: "#000000", popular: true },
    { name: "Navy", hex: "#000080", popular: true },
    { name: "Burgundy", hex: "#800020", popular: true },
    { name: "Emerald", hex: "#50C878", popular: false },
    { name: "Charcoal", hex: "#36454F", popular: false },
  ],
  bridesmaid: [
    { name: "Sage Green", hex: "#9DC183", popular: true },
    { name: "Dusty Rose", hex: "#DCAE96", popular: true },
    { name: "Lavender", hex: "#E6E6FA", popular: true },
    { name: "Terracotta", hex: "#E2725B", popular: false },
    { name: "Mauve", hex: "#E0B0FF", popular: false },
  ],
  quinceanera: [
    { name: "Pink", hex: "#FFC0CB", popular: true },
    { name: "Peach", hex: "#FFDAB9", popular: true },
    { name: "Coral", hex: "#FF7F50", popular: true },
    { name: "Lilac", hex: "#C8A2C8", popular: false },
    { name: "Aqua", hex: "#00FFFF", popular: false },
  ],
  prom: [
    { name: "Royal Blue", hex: "#4169E1", popular: true },
    { name: "Red", hex: "#FF0000", popular: true },
    { name: "Gold", hex: "#FFD700", popular: true },
    { name: "Silver", hex: "#C0C0C0", popular: false },
    { name: "Hot Pink", hex: "#FF69B4", popular: false },
  ],
  custom: [
    { name: "White", hex: "#FFFFFF", popular: true },
    { name: "Black", hex: "#000000", popular: true },
    { name: "Red", hex: "#FF0000", popular: true },
    { name: "Blue", hex: "#0000FF", popular: true },
    { name: "Pink", hex: "#FFC0CB", popular: true },
    { name: "Purple", hex: "#800080", popular: true },
    { name: "Green", hex: "#008000", popular: true },
  ],
};

// Default colors for each preset (most popular)
export const DEFAULT_COLORS = {
  wedding: "White",
  formal: "Black",
  bridesmaid: "Sage Green",
  quinceanera: "Pink",
  prom: "Royal Blue",
  custom: "White",
};

// Style options configuration for each dress preset type
// If a preset doesn't specify options, all options from DRESS_STYLE_OPTIONS are available
export const STYLE_OPTIONS_BY_PRESET: Record<
  string,
  {
    lengths?: readonly string[];
    sleeves?: readonly string[];
    sleeveAddons?: readonly string[];
    necklines?: readonly string[];
    silhouettes?: readonly string[];
    fabrics?: readonly string[];
  }
> = {
  quinceanera: {
    // Quinceanera dresses should not show silhouette choices
    silhouettes: [],
    // Quinceanera dresses should not show asymmetric/cutout addons
    sleeveAddons: [],
  },
  // Other presets can have custom configurations in the future
  // For now, undefined means all options are available
};
